import { Account } from '@ndvr/portfolio-api';

type TaxBudgetAccount = Pick<Account, 'taxBudget' | 'taxBudgetYear'>;

export type EffectiveTaxBudget = { kind: 'amount'; amount: number } | { kind: 'unlimited' } | { kind: 'none' };

export const getEffectiveTaxBudget = (
    account: TaxBudgetAccount,
    currentYear = new Date().getFullYear(),
): EffectiveTaxBudget => {
    if (account.taxBudgetYear !== currentYear) return { kind: 'none' };
    if (account.taxBudget == null) return { kind: 'unlimited' };
    return { kind: 'amount', amount: Number(account.taxBudget) };
};

export const getTaxBudgetUsage = (budget: number, tax: number) => {
    const consumed = Math.max(0, tax);
    const overBudget = consumed > budget;
    const percent = budget > 0 ? Math.min(100, Math.round((consumed / budget) * 100)) : consumed > 0 ? 100 : 0;
    return { consumed, overBudget, percent };
};
